import { render } from "./ProprietaireRegister.vue?vue&type=template&id=48f97972&scoped=true"
import script from "./ProprietaireRegister.vue?vue&type=script&lang=js"
export * from "./ProprietaireRegister.vue?vue&type=script&lang=js"

import "./ProprietaireRegister.vue?vue&type=style&index=0&id=48f97972&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f97972"]])

export default __exports__